/**
 * @description 기타 쿼리 키 모음
 *
 * 특정 도메인에 속하지 않는 범용 쿼리 키를 관리합니다.
 *
 * - myAssets: 내 자산 목록
 * - dataServices: 데이터 서비스 목록
 * - platformLineage: 플랫폼 계보 정보
 * - tagDistribution: 태그 분포 정보
 * - performanceLogs: 성능 로그
 * - assetDataInsights: 자산 데이터 인사이트 (서비스별 통계)
 *
 * @example
 * ```ts
 * // 내 자산 목록 조회
 * queryKey: miscKeys.myAssets()
 *
 * // 특정 서비스의 데이터 인사이트 조회
 * queryKey: miscKeys.assetDataInsights(serviceName, startDate, endDate)
 * ```
 */
export const miscKeys = {
  all: ['misc'] as const,

  myAssetsPrefix: () => [...miscKeys.all, 'myAssets'] as const,
  myAssets: () => [...miscKeys.myAssetsPrefix()] as const,

  dataServicesPrefix: () => [...miscKeys.all, 'dataServices'] as const,
  dataServices: () => [...miscKeys.dataServicesPrefix()] as const,

  platformLineagePrefix: () => [...miscKeys.all, 'platformLineage'] as const,
  platformLineage: (
    view: string,
    upstreamDepth: number,
    downstreamDepth: number,
    includeDeleted: boolean,
    size: number
  ) => [...miscKeys.platformLineagePrefix(), view, upstreamDepth, downstreamDepth, includeDeleted, size] as const,

  tagDistributionPrefix: () => [...miscKeys.all, 'tagDistribution'] as const,
  tagDistribution: () => [...miscKeys.tagDistributionPrefix()] as const,

  performanceLogsPrefix: () => [...miscKeys.all, 'performanceLogs'] as const,
  performanceLogs: () => [...miscKeys.performanceLogsPrefix()] as const,
  performanceLog: (id: string) => [...miscKeys.performanceLogsPrefix(), id] as const,

  assetDataInsightsPrefix: () => [...miscKeys.all, 'assetDataInsights'] as const,
  assetDataInsights: (serviceName: string, startDate: string, endDate: string) =>
    [...miscKeys.assetDataInsightsPrefix(), serviceName, startDate, endDate] as const,
} as const;
